import { createTheme, CustomTheme } from '@ibe/components';
import styles from './Bootstrap.scss';
import './legoland.scss';

const customTheme: CustomTheme = {
  bootstrap: styles,
  paxSelectionOptions: {
    withIcon: true,
    shortTitle: false,
    longTitle: true,
    staticTitle: false,
    displayStaticTitleOnlyBeforeSelection: false,
    validations: {
      adultsRequired: true
    }
  }
};

const theme = createTheme(customTheme);
export default theme;
